import React, {useContext} from "react";
import { Modal, ModalDialog, ModalContent, ModalBody, ModalBackdrop, CloseButton } from "../Modal"
import {CloseIcon} from "../Icons"
import { Context } from "../context";
import JoinForm from "../JoinForm";

const RequestModal = ({ location }) => {
  const {popupContext, setPopupContext} = useContext(Context);
  return (
    <>
      <Modal className="modal" hidden={!popupContext.isVisible} >
        <ModalDialog className="modal-dialog modal-dialog-centered">
          <ModalContent className="modal-content">              
            <ModalBody className="modal-body">
              <CloseButton className="close" onClick={() => setPopupContext({
                isVisible: false,
                thanksURL: "",
              })}><CloseIcon /></CloseButton>
              <JoinForm location={location} thanksURL={popupContext.thanksURL} />
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
      <ModalBackdrop hidden={!popupContext.isVisible} />
    </>
  )
}

export default RequestModal